import { render, staticRenderFns } from "./coupons.vue?vue&type=template&id=66ee557c&scoped=true"
import script from "./coupons.vue?vue&type=script&lang=js"
export * from "./coupons.vue?vue&type=script&lang=js"
import style0 from "./coupons.vue?vue&type=style&index=0&id=66ee557c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ee557c",
  null
  
)

export default component.exports